import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, finalize } from 'rxjs'

import { ApiActivitiesService } from '../api/api-activities.service'
import { IResponse } from '@data/interfaces/iresponseArray.interface'
import { IActivity, IActivityComment, IActivityHistory } from '../../interfaces/activity.interface'

@Injectable({ providedIn: 'root' })
export class FunnelTasksViewService {
  private selectedSubject = new BehaviorSubject<IActivity | null>(null)
  public selected$: Observable<IActivity | null> = this.selectedSubject.asObservable()

  private commentsSubject = new BehaviorSubject<IActivityComment[]>([])
  public comments$: Observable<IActivityComment[]> = this.commentsSubject.asObservable()

  private historySubject = new BehaviorSubject<IActivityHistory[]>([])
  public history$: Observable<IActivityHistory[]> = this.historySubject.asObservable()

  private loadingSubject = new BehaviorSubject<boolean>(false)
  public loading$: Observable<boolean> = this.loadingSubject.asObservable()

  constructor(private api: ApiActivitiesService) {}

  loadDetail(id: string): void {
    this.loadingSubject.next(true)
    this.api
      .getById(id)
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe({ next: (r) => this.selectedSubject.next(r?.data ?? null) })
    this.api.getComments(id).subscribe({ next: (r) => this.commentsSubject.next((r?.data as any) ?? []) })
    this.api.getHistory(id).subscribe({ next: (r) => this.historySubject.next((r?.data as any) ?? []) })
  }

  changeState(id: string, newState: string, comment?: string): Observable<IResponse> {
    //* el funnel no usa adminOverride; lo omite (firma única del motor compartido)
    return this.api.changeState(id, { newState, comment })
  }

  addComment(id: string, content: string, mentions: string[] = []): Observable<IResponse> {
    return this.api.addComment(id, { content, mentions })
  }

  refreshComments(id: string): void {
    this.api.getComments(id).subscribe({ next: (r) => this.commentsSubject.next((r?.data as any) ?? []) })
  }

  clear(): void {
    this.selectedSubject.next(null)
    this.commentsSubject.next([])
    this.historySubject.next([])
  }
}
